import defaults from "./siteDefaults.json";

export const SITE_NAME = defaults.name;
export const DEFAULT_PUBLIC_SITE_URL = defaults.publicSiteUrl;

const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

export const PUBLIC_SITE_URL = trimTrailingSlash(
  process.env.REACT_APP_PUBLIC_SITE_URL || DEFAULT_PUBLIC_SITE_URL
);

export const API_BASE_URL = trimTrailingSlash(
  // process.env.REACT_APP_API_BASE_URL || "https://sabaserver.brainbbox.com"
  process.env.REACT_APP_API_BASE_URL || defaults.apiBaseUrl
);

export const ASSET_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_ASSET_BASE_URL || API_BASE_URL
);

export const DEFAULT_SOCIAL_IMAGE = defaults.socialImage;
export const SUPPORTED_SEO_LANGUAGES = ["en", "ps", "fa"];
export const DEFAULT_SEO_LANGUAGE = "en";

export const localizedRoutePath = (pathname, languageCode = DEFAULT_SEO_LANGUAGE) =>
  `${normalizePathname(pathname)}?lang=${SUPPORTED_SEO_LANGUAGES.includes(languageCode) ? languageCode : DEFAULT_SEO_LANGUAGE}`;

export const normalizePathname = (pathname = "/") => {
  const path = String(pathname || "/").split("?")[0].split("#")[0] || "/";
  const withLeadingSlash = path.startsWith("/") ? path : `/${path}`;
  return withLeadingSlash.length > 1 ? withLeadingSlash.replace(/\/+$/, "") : "/";
};

export const absoluteSiteUrl = (pathname = "/") =>
  new URL(normalizePathname(pathname), `${PUBLIC_SITE_URL}/`).href;

export const absoluteAssetUrl = (assetPath = DEFAULT_SOCIAL_IMAGE) => {
  const value = String(assetPath || DEFAULT_SOCIAL_IMAGE);
  if (/^https?:\/\//i.test(value)) return value;

  const assetBase =
    value.startsWith("/images/") ||
    value.startsWith("/files/") ||
    value.startsWith("/uploads/") ||
    value.startsWith("/online-registration/")
      ? ASSET_BASE_URL
      : PUBLIC_SITE_URL;

  return new URL(value, `${assetBase}/`).href;
};

export const localizedRouteUrl = (pathname = "/", languageCode = DEFAULT_SEO_LANGUAGE) => {
  const url = new URL(normalizePathname(pathname), `${PUBLIC_SITE_URL}/`);
  url.searchParams.set("lang", SUPPORTED_SEO_LANGUAGES.includes(languageCode) ? languageCode : DEFAULT_SEO_LANGUAGE);
  return url.href;
};
